/* tslint:disable */

/**
 */
export class MembershipSwapForm {
    id?: number;
    rfid?: string;
}
